// Takes a toast out of the stack: it fades out first, then gives up its height, so
// the toasts below it slide up instead of jumping. Closing it by hand is twice as
// fast as letting it run out — the user asked for it to go.
const FADE = 400
const COLLAPSE = 250

export function dismissToast(toast, { fast = false } = {}) {
  if (toast.classList.contains('app-toast--leaving')) return

  const speed = fast ? 2 : 1
  toast.classList.add('app-toast--leaving')

  toast.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE / speed, fill: 'forwards' })
    .finished
    .then(() => {
      const marginBottom = getComputedStyle(toast).marginBottom
      return toast.animate([
        { height: `${toast.offsetHeight}px`, marginBottom },
        { height: '0px', marginBottom: '0px' },
      ], { duration: COLLAPSE / speed, easing: 'ease-in', fill: 'forwards' }).finished
    })
    .then(() => up.destroy(toast))
}
